jQuery(document).ready(function($) {
  $(".new-form .hdt-product-form__submit").click(function(e) {
    var isValid = true;
    $(".messages").text("");
    var name = $("#text-1").val();
    if (!name) {
      $("#text-1").siblings(".messages").text("Full Name is required.");
      isValid = false;
    }

    var dob = $("#datetime-1").val();
    if (!dob) {
      $("#datetime-1").siblings(".messages").text("Date of Birth is required.");
      isValid = false;
    }

    var btime = $("#datetime-2").val();
    if (!btime) {
      $("#datetime-2").siblings(".messages").text("Birth Time is required.");
      isValid = false;
    }

    var gender = $("#select-1").val();
    if (gender === "") {
      $("#select-1").siblings(".messages").text("Gender is required.");
      isValid = false;
    }

    var location = $("#text-2").val();
    if (!location) {
      $("#text-2").siblings(".messages").text("Location is required.");
      isValid = false;
    }

    var phone = $("#phone-1").val();
    if (!phone) {
      $("#phone-1").siblings(".messages").text("Phone is required.");
      isValid = false;
    }

    var email = $("#email-1").val();
if (!email) {
    $("#email-1").siblings(".messages").text("Email is required.");
    isValid = false;
} else {
    // Regular expression for basic email validation
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
        $("#email-1").siblings(".messages").text("Please enter a valid email address.");
        isValid = false;
    } else {
        // Clear any previous error messages
        $("#email-1").siblings(".messages").text("");
    }
}
//return false;
    if (isValid) {
      let productId = jQuery('#pro_id').val();
      $('.hdt-product-form__submit').attr('type', 'submit');
      $('.new-form').submit();
 


    // AJAX request to Shopify's cart API
  /*  fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
        // Redirect to checkout or show confirmation message
        window.location.href = "/checkout";
    })
    .catch(error => {
        console.error("Error adding to cart:", error);
    });
*/

    const data = {
        id: productId,
        quantity: 1, // Adjust quantity as needed
        properties: {
            "fullname": name,
            "datetime-1": dob,
            "btime": btime,
            "gender": gender,
            "location": location,
            "phone": phone,
            "email": email
        }
    };  

      // Add product to cart using fetch and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
         // items: [{ id: productId, quantity: 1 }]
          items: [data]
          
        })
      })
      .then(response => response.json())
      .then(data => {
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 500);
      })
      .catch(error => console.error("Failed to add product to cart:", error)); 
    }
  });



  function updateHiddenField() {
        var countryCode = $('#c_code').val(); // Get the selected country code
        var phoneNumber = $('#hide_phone').val(); // Get the phone number

        // Combine both values
        var combinedValue = countryCode + phoneNumber;

        // Set the combined value in the hidden input field
        $('#phone-1').val(combinedValue);
    }

    // Event listener for changes in the select dropdown
    $('#c_code').on('change', function() {
        updateHiddenField();
    });

    // Event listener for changes in the phone number input
    $('#hide_phone').on('input', function() {
        updateHiddenField();
    });



jQuery("#datetime-1").datepicker({
		showOn: "both", // Show the calendar icon both on focus and button click
		buttonImage: "https://cdn.shopify.com/s/files/1/0732/4637/6250/files/cal.png?v=1730809343",
		buttonImageOnly: true, // Display only the icon without text field
		buttonText: "Select date", // Tooltip for the icon
		dateFormat: "dd-mm-yy" // Format of the selected date
  });
jQuery('#datetime-2').timepicker({
                timeFormat: 'H:i', // Use 'H:i' for 24-hour format
                interval: 30, // Set the interval (in minutes)
                minTime: '0', // Minimum time (00:00)
                maxTime: '23:59', // Maximum time (23:59)
                startTime: '00:00', // Start time for the picker
                dynamic: false, // Disable dynamic option
                dropdown: true, // Show dropdown
                scrollbar: true // Show scrollbar
            });



// jQuery("#datetime-1").datepicker({
//     showOn: "both",
//     buttonImage: "https://cdn.shopify.com/s/files/1/0732/4637/6250/files/cal.png?v=1730809343",
//     buttonImageOnly: true,
//     buttonText: "Select date",
//     dateFormat: "dd-mm-yy"
// });

// jQuery('#datetime-2').timepicker({
//     timeFormat: 'h:i', // Enforce 24-hour format
//     interval: 30,
//     minTime: '00:00',
//     maxTime: '23:59',
//     startTime: '00:00',
//     dynamic: false,
//     dropdown: true,
//     scrollbar: true,
//     showPeriodLabels: false, // Hide AM/PM labels
//     change: function(time) {
//         // Additional logic to ensure 24-hour format output
//         const formattedTime = jQuery.timepicker.formatTime('H:i', time);
//         jQuery(this).val(formattedTime);
//     }
// });

  
});


/*
document.getElementById('namenumbercalc').addEventListener('keyup', function () {
    const value = this.value;
    const result = calculateNumerologyValues(value);
    console.log(result);
    document.getElementById('aa').textContent = result.a;
    document.getElementById('bb').textContent = result.b;
    document.getElementById('cc').textContent = result.c;
    document.getElementById('dd').textContent = result.d;
    document.getElementById('ee').textContent = result.e;
});

*/
 document.addEventListener('DOMContentLoaded', function () {
  if (window.currentPageId === 136393720122) {
    const input = document.getElementById('namenumbercalc');
    const loader = document.getElementById('loader');
    const resultTable = document.getElementById('resulttablenumeo');

    if (!input) return;

    // Hide result section initially
    //if (resultTable) resultTable.style.display = 'none';

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
      if (loader) loader.style.display = 'block';
      if (resultTable) resultTable.style.display = 'none';
    });

    input.addEventListener('keyup', function () {
      const value = this.value.trim().toLowerCase();

      // Simulate small processing delay (optional)
      setTimeout(function () {
        const result = calculateNumerologyValues(value);

        if (loader) loader.style.display = 'none';
        if (resultTable) resultTable.style.display = 'block';

        document.getElementById('aa').textContent = result.a;
        document.getElementById('bb').textContent = result.b;
        document.getElementById('cc').textContent = result.c;
        document.getElementById('dd').textContent = result.d;
        document.getElementById('ee').textContent = result.e;
      }, 200); // Delay to simulate calculation time
    });

    function calculateNumerologyValues(input) {
      let a = 0, b = 0, c = 0, d = 0, e = 0;

      for (let i = 0; i < input.length; i++) {
        const ch = input[i];
        let lvalA = 0, lvalB = 0, lvalC = 0, lvalD = 0, lvalE = 0;

        switch (ch) {
          case 'a': lvalA = 1; lvalB = 1; lvalC = 1; lvalD = 1; lvalE = 1; break;
          case 'b': lvalA = 2; lvalB = 2; lvalC = 2; lvalD = 2; lvalE = 2; break;
          case 'c': lvalA = 3; lvalB = 3; lvalC = 3; lvalD = 2; lvalE = 3; break;
          case 'd': lvalA = 4; lvalB = 4; lvalC = 4; lvalD = 4; lvalE = 4; break;
          case 'e': lvalA = 5; lvalB = 5; lvalC = 5; lvalD = 5; lvalE = 5; break;
          case 'f': lvalA = 6; lvalB = 6; lvalC = 8; lvalD = 8; lvalE = 0; break;
          case 'g': lvalA = 7; lvalB = 7; lvalC = 3; lvalD = 3; lvalE = 3; break;
          case 'h': lvalA = 8; lvalB = 8; lvalC = 5; lvalD = 8; lvalE = 8; break;
          case 'i': lvalA = 9; lvalB = 9; lvalC = 1; lvalD = 1; lvalE = 10; break;
          case 'j': lvalA = 1; lvalB = 10; lvalC = 1; lvalD = 1; lvalE = 0; break;
          case 'k': lvalA = 2; lvalB = 11; lvalC = 2; lvalD = 2; lvalE = 20; break;
          case 'l': lvalA = 3; lvalB = 12; lvalC = 3; lvalD = 3; lvalE = 30; break;
          case 'm': lvalA = 4; lvalB = 13; lvalC = 4; lvalD = 4; lvalE = 40; break;
          case 'n': lvalA = 5; lvalB = 14; lvalC = 5; lvalD = 5; lvalE = 50; break;
          case 'o': lvalA = 6; lvalB = 15; lvalC = 7; lvalD = 7; lvalE = 70; break;
          case 'p': lvalA = 7; lvalB = 16; lvalC = 8; lvalD = 8; lvalE = 80; break;
          case 'q': lvalA = 8; lvalB = 17; lvalC = 1; lvalD = 1; lvalE = 80; break;
          case 'r': lvalA = 9; lvalB = 18; lvalC = 2; lvalD = 2; lvalE = 100; break;
          case 's': lvalA = 1; lvalB = 19; lvalC = 3; lvalD = 3; lvalE = 300; break;
          case 't': lvalA = 2; lvalB = 20; lvalC = 4; lvalD = 4; lvalE = 400; break;
          case 'u': lvalA = 3; lvalB = 21; lvalC = 6; lvalD = 6; lvalE = 0; break;
          case 'v': lvalA = 4; lvalB = 22; lvalC = 6; lvalD = 6; lvalE = 6; break;
          case 'w': lvalA = 5; lvalB = 23; lvalC = 6; lvalD = 6; lvalE = 0; break;
          case 'x': lvalA = 6; lvalB = 24; lvalC = 5; lvalD = 6; lvalE = 0; break;
          case 'y': lvalA = 7; lvalB = 25; lvalC = 1; lvalD = 1; lvalE = 0; break;
          case 'z': lvalA = 8; lvalB = 26; lvalC = 7; lvalD = 7; lvalE = 7; break;
          case '1': case '2': case '3': case '4': case '5':
          case '6': case '7': case '8': case '9':
            lvalA = lvalB = lvalC = lvalD = lvalE = parseInt(ch);
            break;
        }

        a += lvalA;
        b += lvalB;
        c += lvalC;
        d += lvalD;
        e += lvalE;
      }

      return { a, b, c, d, e };
    }
  }
});
